<div *ngIf="displayMode === DisplayMode.Desktop" class="fcp-bottom-bar-container" data-e2e-hook="summary_bar">
    <div class="fcp-bottom-bar-title fcp-text-body-l" data-e2e-hook="summary_bar_title">
        <ng-container *ngIf="enabled">
            {{ title || '' }}
        </ng-container>
    </div>
    <div class="fcp-bottom-bar-content fcp-text-body-l">
        <div class="fcp-bottom-bar-content-item" *ngFor="let item of summaryItems; let i = index">
            <ng-container *ngIf="enabled && !hideSummary">
                <span> {{ item.title }}<span *ngIf="item.value !== null"> :</span></span>
                <span *ngIf="item.value !== null" class="fcp-bottom-bar-content-value">{{ item.value }}</span>
                <ng-container
                    *ngIf="itemSuffixTemplate"
                    [ngTemplateOutlet]="itemSuffixTemplate"
                    [ngTemplateOutletContext]="{ item: item, index: i }"
                ></ng-container>
            </ng-container>
        </div>
    </div>
    <div class="fcp-bottom-bar-action fcp-text-body-l">
        <fcp-button-split
            *ngIf="splitMenuButton"
            [menuPosition]="menuPosition"
            [buttonText]="splitMenuButton.label"
            [buttonSize]="splitMenuButton.size"
            [list]="splitMenuButton.items"
            [color]="splitMenuButton.color"
            [disabled]="!splitMenuButton.enabled || !enabled"
            [menuColor]="splitMenuButton.menuColor"
            [menuStyle]="splitMenuButton.menuStyle"
            [variant]="splitMenuButton.variant"
            (onClick)="onSplitMenuClick.emit()"
        >
        </fcp-button-split>
        <button
            fcp-button
            class="fcp-summary-bar-main-button"
            [disabled]="!mainButton?.enabled || !enabled"
            [color]="mainButton?.color"
            [size]="mainButton?.size"
            (click)="onClick.emit()"
            data-e2e-hook="summary_bar_button1"
            *ngIf="mainButton?.label"
        >
            {{ mainButton?.label }}
        </button>
        <button
            fcp-outlined-button
            class="fcp-summary-bar-secondary-button"
            [size]="additionalButton?.size"
            [color]="additionalButton?.color"
            [disabled]="!additionalButton?.enabled || !enabled"
            (click)="onSecondaryClick.emit()"
            data-e2e-hook="summary_bar_button2"
            *ngIf="additionalButton?.label || additionalButton?.icon"
        >
            <fcp-icon
                *ngIf="additionalButton?.icon?.length"
                [icon]="additionalButton?.icon"
                style="font-size: 16px"
            ></fcp-icon>
            {{ additionalButton?.label }}
        </button>
        <button
            fcp-outlined-button
            [size]="secondAdditionalButton?.size"
            [color]="secondAdditionalButton?.color"
            [disabled]="!secondAdditionalButton?.enabled"
            (click)="secondAdditionalButton?.enabled && onSecondSecondaryClick.emit()"
            data-e2e-hook="summary_bar_button3"
            *ngIf="secondAdditionalButton?.label || secondAdditionalButton?.icon"
        >
            <fcp-icon
                *ngIf="secondAdditionalButton?.icon?.length"
                [icon]="secondAdditionalButton?.icon"
                style="font-size: 16px"
            ></fcp-icon>
            {{ secondAdditionalButton?.label }}
        </button>
    </div>
</div>

<div *ngIf="displayMode === DisplayMode.Mobile" class="fcp-bottom-bar-container-mobile" id="bottom-bar-container">
    <div class="fcp-bottom-bar-content-mobile fcp-text-body-l">
        <div class="fcp-bottom-bar-content-mobile-item">
            <ng-container *ngIf="enabled">
                <div class="fcp-bottom-bar-content-mobile-item-container" *ngFor="let item of summaryItems">
                    <span class="fcp-bottom-bar-content-mobile-text"> {{ item.title }}:</span>
                    <span class="fcp-bottom-bar-content-mobile-value">{{ item.value }}</span>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="fcp-bottom-bar-mobile-action fcp-text-body-l">
        <button
            class="fcp-bottom-bar-mobile-button"
            fcp-button
            (click)="onClick.emit()"
            [disabled]="!mainButton.enabled || !enabled"
            [color]="mainButton.color"
            *ngIf="mainButton.label"
        >
            {{ mainButton.label }}
        </button>
        <button
            fcp-outlined-button
            [color]="additionalButton.color"
            [class]="{
                'fcp-bottom-bar-mobile-button': additionalButton.label
            }"
            (click)="onSecondaryClick.emit()"
            [disabled]="!additionalButton.enabled || !enabled"
            *ngIf="additionalButton"
        >
            <fcp-icon
                *ngIf="additionalButton.icon?.length"
                [icon]="additionalButton.icon"
                style="font-size: 16px"
            ></fcp-icon>
            {{ additionalButton.label }}
        </button>
        <button
            fcp-outlined-button
            [color]="secondAdditionalButton.color"
            [class]="{
                'fcp-bottom-bar-mobile-button': secondAdditionalButton.label
            }"
            (click)="secondAdditionalButton.enabled && onSecondSecondaryClick.emit()"
            [disabled]="!secondAdditionalButton.enabled"
            *ngIf="secondAdditionalButton"
        >
            <fcp-icon
                *ngIf="secondAdditionalButton.icon?.length"
                [icon]="secondAdditionalButton.icon"
                style="font-size: 16px"
            ></fcp-icon>
            {{ secondAdditionalButton.label }}
        </button>
    </div>
</div>
